var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1088 10.2978C14.1088 9.92152 13.7717 9.63381 13.3308 9.63381C12.8899 9.63381 12.5527 9.92152 12.5527 10.2978C12.5527 12.8871 10.0888 14.9896 7.05441 14.9896C4.01998 14.9896 1.55612 12.8871 1.55612 10.2978C1.55612 9.92152 1.21896 9.63381 0.77806 9.63381C0.337159 9.63381 0 9.92152 0 10.2978C0 13.374 2.69728 15.9634 6.27635 16.2954V18.0659H3.4494C3.0085 18.0659 2.67134 18.3536 2.67134 18.7299C2.67134 19.1061 3.0085 19.3938 3.4494 19.3938H10.6594C11.1003 19.3938 11.4375 19.1061 11.4375 18.7299C11.4375 18.3536 11.1003 18.0659 10.6594 18.0659H7.83247V16.2954C11.4116 15.9634 14.1088 13.374 14.1088 10.2978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05441 0.582031C4.66836 0.582031 2.72321 2.24189 2.72321 4.27799L2.72321 10.2756C2.72321 12.3339 4.66836 13.9716 7.05441 13.9937C9.44047 13.9937 11.3856 12.3339 11.3856 10.2978V4.27799C11.3856 2.24189 9.44047 0.582031 7.05441 0.582031Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon_microphone.087b72ced05fd9ddb127d869b40f46f8.svg";
export { ForwardRef as ReactComponent };